import jump from 'jump.js';

const handlers = new WeakMap();

export default {
  bind(el, options = {}) {
    const { target, config } = options;

    if (!target) return;

    const handler = (e) => {
      e.preventDefault();
      jump(target, config);
    };

    el.addEventListener('click', handler);
    handlers.set(el, handler);
  },

  unbind(el) {
    const handler = handlers.get(el);
    if (handler) {
      el.removeEventListener('click', handler);
      handlers.delete(el);
    }
  },
};
